import React from 'react';

const Terms = () => {
  return (
    <div className="px-4 py-8 sm:px-6 md:mt-28 lg:px-8">
      <div className="prose prose-lg max-w-none">
        <h1 className="text-3xl font-bold text-gray-900 mb-4">Terms & Conditions</h1>
        <p className="text-gray-600 mb-8">Last Updated: June 2025</p>

        <p className="text-gray-700 mb-6">
          These terms and conditions outline the rules and regulations for the use of our Website. By accessing this website we assume you accept these terms and conditions. Do not continue to use our website if you do not agree to take all of the terms and conditions stated on this page.
        </p>

        <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">Terminology</h2>
        <p className="text-gray-700 mb-6">
          The following terminology applies to these Terms and Conditions, Privacy Statement and Disclaimer Notice, and all Agreements: "Client", "You" and "Your" refers to you, the person who logs on to this website and is compliant with the Company's terms and conditions. "The Company", "Ourselves", "We", "Our" and "Us", refers to our Company. "Party", "Parties", or "Us", refers to both the Client and ourselves.
        </p>

        <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">Cookies</h2>
        <p className="text-gray-700 mb-6">
          We employ the use of cookies. By accessing our website, you agree to use cookies in agreement with our Privacy Policy. Most interactive websites use cookies to let us retrieve the user's details for each visit. Cookies are used by our website to enable the functionality of certain areas to make it easier for people visiting our website. Some of our affiliate/advertising partners may also use cookies.
        </p>

        <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">Intellectual Property</h2>
        <p className="text-gray-700 mb-6">
          Unless otherwise stated, we and/or our licensors own the intellectual property rights for all material on our website. All intellectual property rights are reserved. You may access this from our website for your personal use subject to restrictions set in these terms and conditions.
        </p>

        <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">User Comments</h2>
        <p className="text-gray-700 mb-6">
          Parts of this website offer an opportunity for users to post and exchange opinions and information in certain areas of the website. We do not filter, edit, publish, or review Comments before their presence on the website. Comments do not reflect the views and opinions of our company, its agents, and/or affiliates. Comments reflect the views and opinions of the person who posts their views and opinions.
        </p>

        <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">Liability</h2>
        <p className="text-gray-700 mb-6">
          We shall not be held responsible for any content that appears on your Website. You agree to protect and defend us against all claims that are arising on your Website. No link(s) should appear on any Website that may be interpreted as libelous, obscene or criminal, or which infringes, otherwise violates, or advocates the infringement or other violation of, any third-party rights.
        </p>

        <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">Modifications</h2>
        <p className="text-gray-700 mb-6">
          We reserve the right to modify these terms at any time. Continued use of our services constitutes acceptance of any changes.
        </p>

        <p className="text-gray-700 mb-6">
          For any questions regarding our terms, please contact <a href="mailto:israelitesshopping171@gmail.com" className="text-blue-600 hover:text-blue-800">israelitesshopping171@gmail.com</a>.
        </p>
      </div>
    </div>
  );
};

export default Terms;